import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  exchangeRate: null,
};

const exchangeSlice = createSlice({
  name: "exchange",
  initialState,
  reducers: {
    addExchangeRate: (state, action) => {
      state.exchangeRate = action.payload;
    },
    removeExchangeRate: (state) => {
      state.exchangeRate = []
    }
  },
});
export const {
    addExchangeRate,
    removeExchangeRate
} = exchangeSlice.actions;
export default exchangeSlice.reducer;
